<template>
  <div style="margin-bottom: 20px">
    <div class="row">
      <div class="col-lg-2">
        <table>
          <tr>
            <td valign="top" style="text-align: right" width="50px">
              <span style="font-size: 44px">{{ itemdate.day }}</span>
            </td>
            <td valign="top" style="padding-left: 10px; padding-top: 10px">
              <span style="font-size: 12px">{{ itemdate.dayname }}</span>
              <br />
              <span style="font-size: 12px"
                >{{ itemdate.month }} {{ itemdate.year }}</span
              >
            </td>
          </tr>
        </table>
      </div>
      <div class="col-lg-10">
        <div class="row" v-for="item in items" :key="item.lessondate">
          <div class="col-lg-2">
            <span style="font-size: 14px">{{
              gethour(item.lessondate, item.duration)
            }}</span>
          </div>
          <div class="col-lg-8">
            <i v-if="item.status === 1" class="text-danger ni t-warning"></i>
            <i v-if="item.status === 2" class="text-orange ni megaphone"></i>
            <i v-if="item.status === 3" class="text-blue ni hourglass"></i>
            <i v-if="item.status === 4" class="text-info ni laptop"></i>
            <i v-if="item.status === 5" class="text-green ni verified"></i>
            <span style="font-size: 14px; padding-left: 10px"
              >{{ item.coursetitle }}. {{ item.stagetitle }}.
              {{ item.title }}</span
            >
            <br />
            <span style="font-size: 12px; padding-left: 25px">{{item.classcode}}. {{
              item.teachername
            }}</span>
          </div>
          <div class="col-lg-2">
            <el-tooltip effect="dark" content="View lesson" placement="top">
              <base-button
                @click.native="onOpen(item)"
                class="secondary"
                type="default"
                size="sm"
                :disabled="item.status <= 2"
                icon
              >
                <i class="text-white ni preview"></i>
              </base-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="View class" placement="top">
              <base-button
                @click.native="onOpenClass(item)"
                class="secondary"
                type="success"
                size="sm"
                icon
              >
                <i class="ni show-room"></i>
              </base-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip, Button } from "element-ui";
export default {
  name: "schedule-item",
  components: {
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },
  props: {
    date: String,
    items: Array,
  },
  data() {
    return {};
  },
  methods: {
    gethour(date, duration) {
      let dtfrom = new Date(date);
      let dtto = new Date(dtfrom.getTime() + duration * 60000);
      //   console.log(dtfrom);
      return (
        dtfrom.getHours().toString().padStart(2, "0") +
        ":" +
        dtfrom.getMinutes().toString().padStart(2, "0") +
        " - " +
        dtto.getHours().toString().padStart(2, "0") +
        ":" +
        dtto.getMinutes().toString().padStart(2, "0")
      );
    },
    onOpen(item) {
      let routeData = this.$router.resolve({
        name: "Lesson",
        params: { id: item.id, classId: item.classid },
      });
      window.open(routeData.href, "_blank");
    },
    onOpenClass(item) {
      let routeData = this.$router.resolve({
        name: "Class",
        params: { id: item.classid },
      });
      window.open(routeData.href, "_blank");
    },
  },
  computed: {
    itemdate() {
      let dt = new Date(this.date);
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return {
        day: dt.getDate(),
        year: dt.getFullYear(),
        month: dt.toLocaleString("default", { month: "short" }),
        dayname: days[dt.getDay()],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  margin: 4px;
}
</style>